export const SHOP_ALL_TEXT = 'Shop all';
